// Las familias de cursos escritas en catalán (C9). Viven aparte porque sus nombres están en catalán:
// «Ortografia» se escribe sin tilde, y `tools/check_tildes.py`, que mira el castellano, se salta
// este fichero. El resto del catálogo está en `emojisDeFamilia.mjs`, que las incluye.
//
// Sus títulos llevan «catalana» a propósito: allí se busca sin tildes y gana el nombre más largo,
// así que «Ortografia» a secas caería en la tarjeta de Ortografía en castellano.

// EL PARAGUAS DE TODOS LOS CURSOS DE CATALÁN (Gabri, 3 nov 2026), como el del castellano, y en
// catalán porque es lo que se estudia.
export const BLOQUE_CATALANA = "Llengua i literatura catalana";

export const FAMILIAS_CATALANAS = [
  // ✍️ LO ELIGIÓ GABRI el 3 de noviembre de 2026. Un solo curso de 1.º a 4.º de ESO.
  { familia: "Ortografia catalana", bloque: BLOQUE_CATALANA, emoji: "✍️" },
];
